/**
 * Bingo Scheduler Item Portlet View
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseView = require('common/base.view');
    var device = require('util/device.util');

    module.exports = BaseView.extend({
        tagName: 'li',

        initialize: function() {
            this.isLazy = this.model.get('config').isLazy;
        },

        attributes: function() {
            return {
                'data-game-code': this.model.id
            };
        },

        className: function() {
            return {
                'LIST': 'fn-launch-game fn-bingoitem bingoitem bingoitem__list paging__item',
                'IMAGE': 'fn-launch-game fn-bingoitem gamesinfo__item gamesinfo__item_style_extended ' +
                'fn-resize-item fn-style-extended bingoitem paging__item',
                'SHORT': 'fn-launch-game fn-bingoitem gamesinfo__item gamesinfo__item_style_extended ' +
                'fn-resize-item fn-style-extended bingoitem paging__item'
            }[this.model.get('config').portletViewMode];
        },

        subscribe: function() {
            this.model.on('change:timeLeftInSeconds', this.updateTime.bind(this));
            this.model.on('destroy', this.close.bind(this));
        },

        updateTime: function() {
            var interval = this.model.get('timeLeftInSeconds');
            var timer = this.$el.find('.fn-bingoitem-timer')[0];

            // If more than 10% visible than update timers
            if (timer && (interval > 0 && !this.isLazy || this.$el.isInViewportByPercentage(0.1))) {
                timer.textContent = ' ' + window.Playtech.API.formatter.formatTimeFromSeconds(Math.floor(interval / 1000));
            }
        },

        getHumanizedDrawDate: function() {
            var date = new Date(this.model.get('drawTime').replace(' ', 'T') + 'Z');
            var formattedDate = window.Playtech.API.formatter.getTimeShort(date);

            return this.translate('playtech.mobile.bingoscheduler.short-week-day.' + date.getDay()) +
                ' ' + formattedDate;
        },

        render: function() {
            var templateName = 'bingo-scheduler.item.' + this.model.get('config').portletViewMode.toLowerCase();

            this.$el.html(this.tmpl(templateName, _.extend({}, this.model.toJSON(),
                {
                    isDesktop: device.formFactor === 'desktop',
                    humanizedDate: this.getHumanizedDrawDate(),
                    formFactor: device.formFactor
                }
            )));

            this.updateTime();

            return this;
        }

    });
});

